import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const SITE_IMAGE_DEFAULTS = {
  // lookbook page (brand photography)
  lab: "/brand/blog-strength.jpg",
  nature: "/brand/hero-immune.jpg",
  dynamic: "/brand/product-focus.jpg",
  woman: "/brand/blog-energy.jpg",
  clean: "/brand/blog-quality.jpg",
  soft: "/brand/product-energy.jpg",
  // home page (brand photography provided by the owner)
  "home-hero": "/brand/hero-immune.jpg",
  "home-immune": "/brand/cat-immune.jpg",
  "home-focus": "/brand/cat-focus.jpg",
  "home-energy": "/brand/cat-energy.jpg",
  "home-performance": "/brand/cat-performance.jpg",
  "home-relaxation": "/brand/cat-relaxation.jpg",
  // about / science pages
  "about-lab": "/brand/blog-strength.jpg",
  "science-lab": "/brand/cat-performance.jpg",
  // brand (AI-generated AP monogram; admin can override via upload)
  logo: "/brand/logo.png",
};

export const SITE_MEDIA_GROUPS = [
  { key: "lookbook", slots: ["lab", "nature", "dynamic", "woman", "clean", "soft"] },
  { key: "home", slots: ["home-hero", "home-immune", "home-focus", "home-energy", "home-performance", "home-relaxation"] },
  { key: "about", slots: ["about-lab"] },
  { key: "science", slots: ["science-lab"] },
  { key: "brand", slots: ["logo"] },
];

export function useSiteMedia() {
  const [slots, setSlots] = useState({});
  useEffect(() => {
    api.siteMedia().then((m) => setSlots(m.slots || {})).catch(() => {});
  }, []);
  return (slot) => slots[slot] || SITE_IMAGE_DEFAULTS[slot];
}
